module.exports = __webpack_public_path__ + "img/qr-poster-template.8d88c324.png";